/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news-feed-general': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M1 5h30v22H1zM26.5 10h-7.018M26.5 14h-7.018M26.5 18h-7.018M26.5 22h-7.018M3 28v2h26v-2"/><path pid="1" d="M10.5 12a5.5 5.5 0 103.89 1.61L10.5 17.5V12zM13.5 8l2 1-2.5 3z"/></g>'
  }
})
